import type { ExperienceProfile } from '@nava/backoffice-bff-contracts';
interface Props {
  profiles: ExperienceProfile[];
  busy: boolean;
  forStudy: boolean;
  onCreate: () => void;
  onEdit: (profile: ExperienceProfile) => void;
  onClone: (profile: ExperienceProfile) => void;
  onArchive: (profile: ExperienceProfile) => void;
}
export function ExperienceProfileList({
  profiles,
  busy,
  forStudy,
  onCreate,
  onEdit,
  onClone,
  onArchive,
}: Props) {
  return (
    <section className="rounded-xl border bg-white p-5">
      <div className="mb-4 flex justify-between">
        <h2 className="font-semibold">Profiles</h2>
        <button
          disabled={busy}
          className="rounded bg-violet-700 px-4 py-2 text-white"
          onClick={onCreate}
        >
          Create profile
        </button>
      </div>
      {!profiles.length && <p>No custom profiles yet. Studies use product-line defaults.</p>}
      <ul className="divide-y">
        {profiles.map((profile) => (
          <li key={profile.id} className="flex flex-wrap items-center justify-between gap-3 py-3">
            <div>
              <strong>{profile.name}</strong>
              <p className="text-sm">
                {profile.description} · Revision {profile.revision} · {profile.status}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                className="underline"
                disabled={profile.status !== 'active' || busy}
                onClick={() => onEdit(profile)}
              >
                Edit
              </button>
              <button className="underline" disabled={busy} onClick={() => onClone(profile)}>
                {forStudy ? 'Clone for this study' : 'Clone'}
              </button>
              <button
                className="underline"
                disabled={profile.status !== 'active' || busy}
                onClick={() => onArchive(profile)}
              >
                Archive
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
